import React from 'react';
import { useSelector } from 'react-redux';
import BasicContainer from '@copilot/common/components/containers/basic';
import { OrganizationSelectors } from '@copilot/common/store/selectors/organization';
import Albato from '@copilot/common/components/snippets/albato';
import { RootState } from '@copilot/common/store/reducers';

interface IOrganizationCrmSettingsProps {
	organizationId: string;
}

/**
 * Organization dashboard tab that displays an admin's CRM configuration for the account
 * @param props 
 * @returns 
 */
const OrganizationCrmConfiguration: React.FC<
	IOrganizationCrmSettingsProps
> = (props) => {
	const { organizationId } = props;
	const organization = useSelector(OrganizationSelectors.getOrganization(organizationId));
    
	const currentUserTenantId = useSelector((state: RootState) => state.app.tenant) ?? '';
	if (!organization) return null;
	return (
		<BasicContainer>
			<BasicContainer.Header>CRM Configuration</BasicContainer.Header>
			<BasicContainer.Content>
                <Albato tenantId={currentUserTenantId}></Albato>
			</BasicContainer.Content>
		</BasicContainer>
	);
};

export default OrganizationCrmConfiguration;
